// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__13d1K","input":"styles_input__Ji86j","label":"styles_label__yTr1B"};